<template>
  <div :class="`methode-card`">

    <div class="methode-card__title">
      <input type="checkbox" name="methodCheckbox" :value="card.id" :id="checkboxValue" v-on:change="saveMethod" :checked="checked"/><label :for="checkboxValue" :id="card.id">{{ card.name_short }}</label>
    </div>

    <div class="methode-card__description" v-html="excerpt">
    </div>

    <div class="qualities">
      <h4>Sterke punten</h4>
      <ul class="qualities__list" v-for="(sterkte, index) in card.strongholds" :key="sterkte.i" :data-index="index">
        <li class="quality"><span class="quality-icon" :class="'icon-'+cleanClass(sterkte)"></span><span class="quality-text">{{ sterkte }}</span></li>
      </ul>
    </div>

    <div class="methode-card__button-holder"><router-link :to="{ name: 'methode-detail', params: { methodeId: card.id, slug: slug } }" :taxonomy="card.term" class="button button--flat">Meer info</router-link></div>

  </div>
</template>

<script>
export default {
  name: "MethodeCard",

  props: {
    card: Object,
    slug: String,
    storeIndex: Number,
    storeMethods: Array
  },

  computed: {
    excerpt() {
      if(this.card.description) {
        let helper = this.card.description.substring(100, this.card.description.length);
        let plusIndex = helper.indexOf(' ');
        return this.card.description.substring(0, 100 + plusIndex) + ' (...)';
      }
    },
    checkboxValue() {
      return 'methodcheck' + this.card.id;
    },
    checked() {
      // check if this id is in the comparedItems array
      return this.storeMethods[this.storeIndex].methods.includes(this.card.id);
    },

  },

  methods: {
    saveMethod: function(event) {
      // use these variables
      const sluggie = this.slug
      let method = this.card.id 
      let idx = this.storeIndex
      let isChecked = event.target.checked;

      if (isChecked) {
        // push the id of the method in checkedMethods[i].methods[]
        this.storeMethods[idx].methods.push(this.card.id);
        this.saveCats();
      }
      if (!isChecked) {
        // remove the id of the method from checkedMethods[i].methods[]
        this.storeMethods[idx].methods.splice(this.storeMethods[idx].methods.indexOf(method), 1);
        this.saveCats();
      }

      // update the counter en de methodsarray in de header (vergelijk button) 
      //this.selected = this.checkedMethods.lenght
      this.$emit('updateCount',this.storeMethods[idx].methods.length) 

    },
    saveCats() {
      // save in localStorage
      const parsed = JSON.stringify(this.storeMethods);
      localStorage.setItem('comparedItems', parsed);
    },

    cleanClass(j) {
      return j.replace(/[^a-z]/gi, '').toLowerCase();
    }

  },

  mounted() {

  }
};
</script>

